import { useCallback, useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UILoadingButton from 'UIComponents/button/UILoadingButton';
import AllInsightsPanel from 'messaging-publishing-lib/Insights/components/AllInsights/AllInsightsPanel';
import { TInsightIcon } from 'messaging-publishing-lib/Insights/components/EmailInsights/InsightIcon';
import { FRAMEWORK_INSIGHT_CONTEXT_TO_COMPARISON_TYPE } from 'messaging-publishing-lib/Insights/constant';
import { getInsightColorTrellis } from 'messaging-publishing-lib/Insights/utils';
import { trackInsightsInteraction } from 'messaging-publishing-lib/utils/tracking';
import useFetchTopPositiveSpotlights from 'messaging-publishing-lib/Insights/hooks/useFetchTopPositiveSpotlights';
import useFetchTopNegativeSpotlights from 'messaging-publishing-lib/Insights/hooks/useFetchTopNegativeSpotlights';
import useFetchSpotlightSentimentCount from 'messaging-publishing-lib/Insights/hooks/useFetchSpotlightSentimentCount';
import { useInsightContext } from './InsightContextProviderBase';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
function InsightButton({
  businessUnitId
}) {
  const [showInsightsPanel, setShowInsightsPanel] = useState(false);
  const {
    context
  } = useInsightContext();
  const {
    data: {
      positiveSpotlightCount,
      negativeSpotlightCount
    },
    loading: spotlightSentimentCountLoading
  } = useFetchSpotlightSentimentCount({
    businessUnitId: Number(businessUnitId),
    comparisonType: FRAMEWORK_INSIGHT_CONTEXT_TO_COMPARISON_TYPE[context]
  });
  const topPositiveSpotlightsPaginated = useFetchTopPositiveSpotlights({
    businessUnitId: Number(businessUnitId),
    comparisonType: FRAMEWORK_INSIGHT_CONTEXT_TO_COMPARISON_TYPE[context]
  });
  const topNegativeSpotlightsPaginated = useFetchTopNegativeSpotlights({
    businessUnitId: Number(businessUnitId),
    comparisonType: FRAMEWORK_INSIGHT_CONTEXT_TO_COMPARISON_TYPE[context]
  });
  const loading = topNegativeSpotlightsPaginated.loading || topPositiveSpotlightsPaginated.loading || spotlightSentimentCountLoading;
  const closeInsightsPanel = useCallback(() => {
    setShowInsightsPanel(false);
  }, [setShowInsightsPanel]);
  const negativeInsightIcon = /*#__PURE__*/_jsx(TInsightIcon, {
    polarity: false,
    size: "100"
  });
  const positiveInsightIcon = /*#__PURE__*/_jsx(TInsightIcon, {
    polarity: true,
    size: "100"
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(UILoadingButton, {
      disabled: loading,
      loading: loading,
      onClick: () => {
        trackInsightsInteraction({
          action: 'open-insights-panel'
        });
        setShowInsightsPanel(true);
      },
      size: "extra-small",
      use: "tertiary-extra-light",
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "messaging-insights.insights.button"
      }), /*#__PURE__*/_jsx("strong", {
        children: /*#__PURE__*/_jsxs(Text, {
          as: "span",
          color: getInsightColorTrellis(false),
          children: [negativeSpotlightCount, " ", negativeInsightIcon]
        })
      }), /*#__PURE__*/_jsx("strong", {
        children: /*#__PURE__*/_jsxs(Text, {
          as: "span",
          color: getInsightColorTrellis(true),
          children: [positiveSpotlightCount, " ", positiveInsightIcon]
        })
      })]
    }), showInsightsPanel && /*#__PURE__*/_jsx(AllInsightsPanel, {
      topPositiveSpotlightsPaginated: topPositiveSpotlightsPaginated,
      topNegativeSpotlightsPaginated: topNegativeSpotlightsPaginated,
      positiveSpotlightCount: positiveSpotlightCount,
      negativeSpotlightCount: negativeSpotlightCount,
      closeInsightsPanel: closeInsightsPanel,
      context: context
    })]
  });
}
export default InsightButton;